import { Navigate, Route, Routes } from 'react-router-dom';
import { useSession } from '../lib/session';
import { EnrollTwoFactor, SetPassword, SignIn, VerifyTwoFactor } from '../components/Auth';
import { Loading } from '../components/ui';
import { PortalLayout, type PortalClient, type PortalUser } from './Layout';
import { CustomerProjects, CustomerProject } from './Projects';
import { BillingDetails } from './BillingAddress';

const BASE = '/api/portal';

export function PortalApp() {
  const session = useSession<PortalUser, PortalClient>(BASE);
  const path = window.location.pathname;

  if (path === '/portal/accept') {
    return <SetPassword base={BASE} endpoint="accept-invite" title="Create your password" blurb="Finish setting up your customer login." onDone={session.refresh} />;
  }
  if (path === '/portal/reset') {
    return <SetPassword base={BASE} endpoint="reset" title="Choose a new password" blurb="Enter a new password for your customer login." onDone={session.refresh} />;
  }
  if (session.status === 'loading') return <Loading />;
  if (session.status === 'anonymous') return <SignIn base={BASE} panelName="Customer portal" onDone={session.refresh} />;
  if (session.status === 'pending') {
    return session.pending === 'enroll_2fa'
      ? <EnrollTwoFactor base={BASE} panelName="Customer portal" required onDone={session.refresh} />
      : <VerifyTwoFactor base={BASE} panelName="Customer portal" onDone={session.refresh} />;
  }

  return (
    <Routes>
      <Route element={<PortalLayout user={session.user!} client={session.context} onSignOut={session.signOut} />}>
        <Route path="/portal" element={<CustomerProjects customerName={session.context?.name ?? 'Your company'} />} />
        <Route
          path="/portal/billing"
          element={
            <BillingDetails
              canEdit={session.user?.role === 'owner' || session.user?.role === 'billing_only'}
              onSaved={session.refresh}
            />
          }
        />
        <Route path="/portal/projects/:id" element={<CustomerProject />} />
        <Route path="*" element={<Navigate to="/portal" replace />} />
      </Route>
    </Routes>
  );
}
